import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const RootContainer = styled(Common.RootContainer)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const TitleSection = styled(Common.TitleSection)``;

export const Title = styled(Common.Title)``;

export const TitleRow = styled(Common.TitleRow)``;

export const SubtitleSection = styled(Common.SubtitleSection)``;

export const SubtitleRow = styled(Common.SubtitleRow)``;

export const Subtitle = styled(Common.Subtitle)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Search = styled(Common.Search)``;

export const Popover = styled(Common.Popover)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const CircularProgress = styled(Common.CircularProgress)``;

export const NotFound = styled(Common.NotFound)``;

export const Button = styled(Common.Button)``;

export const FilterButton = styled(Common.Button)`
	color: ${Theme.black} !important;
`;

export const TableContainer = styled(Common.TableContainer)``;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)`
`;

export const TableColumn = styled(Common.TableColumn)`
	padding-top: 1.5rem !important;
	padding-bottom: 0.75rem !important;
`;

export const OrderStatus = styled(Common.FlexRow)`
	width: 80%;
	padding: 0.5rem 0px 0.5rem;
	margin: -0.5rem auto 0 auto !important;
	justify-content: center;
	line-height: 18px;
	font-size: 12px;
	font-weight: 700;
	border-radius: 100px;
	text-transform: uppercase;
`;

export const TablePagination = styled(Common.TablePagination)``;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DateRangePicker = styled(Common.DateRangePicker)``;

export const SquareButton = styled(Common.SquareButton)``;
